// eslint-disable-next-line
export default {
    translations: { // Mesmo valor usado nas configurações (defaultNS)
        header: {
            who: 'QUEM SOU EU?',
            projects: 'PROJETOS'
        },
        footer: {
            contact: 'CONTATO',
            phone: 'Celular',
            email: 'E-mail:',
            address: 'Endereço:',
        },
        who: {
            about: 'SOBRE MIM',
            title: "Desenvolvedor Full-stack",
            subtitle: 'na Accordous',
            description: 'Sou desenvolvedor Full Stack na Accordous contribuindo com o desenvolvimento de APIs, componentes de interface e UX para diversos clientes brasileiros em uma equipe pequena e eficiente. Estamos trabalhando com frameworks para linguagens PHP e JS na stack Laravel + VueJs.'
        },
        projects: {
            experience: 'Experiência',
            accordous: {
                enterprise: 'Accordous',
                position: 'Desenvolvedor Full-stack',
                description: "Atualmente trabalho na Accordous, contribuo com o desenvolvimento de novas funcionalidades, " +
                    "experiência do usuário e componente de interface para dezenas de clientes no Brasil e realização de tarefas Full-Stack" +
                    " ao lado de equipes de desenvolvimento com linguagens de programação como PHP, Javascript. Sou responsável por " +
                    "a implementação de novas interfaces responsivas e novos recursos, usando Docker, fluxo com CI / CD e seguidor " +
                    "de ideias de código claras, também usando métodos como Scrum para agilizar a implantação de novos recursos no sistema.",
            },
            genesis: {
                enterprise: 'Gênesis Tecnologia',
                position: 'Desenvolvedor Full-stack Junior',
                description: "A Gênesis Tecnologia e Inovação é uma empresa focada no desenvolvimento de soluções para gestão pública, na qual desenvolvi e contribuí para a criação do sistema de gestão escolar feito em React.JS e Laravel. Criei dezenas de módulos para o sistema, sendo o sistema implatado em dezenas de cidades do Mato Grosso do Sul ao lado de uma equipes com 6 programadores no qual eu era o único desenvolvedor full-stack do desenvolvimento, utilizamos diferentes linguagens de programação como Javascript, PHP, eu desenvolvi o sistema utilizando modelagem DDD e TDD, desenvolvi API, prototipei e gerenciei a stack de UX Design, utilizei de ferramente de css o styled component para componentizar telas, fiz testes de integração backend e segui junto com a equipe a ferramenta de desenvolvimento de software scrum para entregas contínuas.",
            }
        },
        other: {
            other: "OUTROS PROJETOS",
            title: "Os sites desenvolvidos",
            herval: {
                enterprise: 'Herval Park Hotel',
                description: 'Fui responsável pelo desenvolvimento do backend e integração com o frontend,' +
                    'Também coloquei o site no ar',
            },
            meltt: {
                enterprise: 'Meltt Eventos',
                description: 'Fui responsável por desenvolver a interface e backend de um sistema de gerenciamento de fotos de trainees com 150 usuários, coloquei no ar.',
            },
            apx: {
                enterprise: 'APX³',
                description: 'Fui responsável pelo desenvolvimento do backend em que utilizei o framework Laravel, ' +
                    'utilizou serviços e repositórios. O sistema é responsável por publicar e gerenciar propriedades para ' +
                    'venda para esta imobiliária.',
            },
            bikcraft: {
                enterprise: 'Bikcraft',
                description: 'Site desenvolvido com html e css para me desenvolver mais no frontend.',
            },
            dona: {
                enterprise: 'Dona Santa Alimentos',
                description: 'Site desenvolvido com html, css, bootstrap e em backend PHP, conexão mysql.',
            },
            result: {
                enterprise: 'Result Now',
                description: 'Site desenvolvido com html, css, bootstrap e em backend PHP, conexão mysql.',
            },
            commands: {
                enterprise: 'Comanda APP',
                description: 'O projeto está no Laravel, ele usou um tema em AdminLTE, mudei para Sego',
            },
            converter: {
                enterprise: 'Conversor CSV',
                description: 'O projeto foi publicado no netlify e foi feito em react.js para receber um csv desestruturado e realizar operações como verificar se o arquivo possui itens repetidos nas linhas agrupando-os e realizando operações de soma entre seus campos',
            },
        },
        packages: {
            other: 'Outros projetos',
            title: 'Pacotes desenvolvidos e contribuições de código aberto',
            digital: {
                title: 'Pacote de Assinaturas Digitais - API D4Sign',
                description: "Eu desenvolvi este pacote focado no Laravel, pois este pacote oficial é feito em PHP, mas este pacote oficial a última atualização na época que eu o criei tinha 3 anos, " +
                    "Vi que não existia tal pacote para o Laravel e desenvolvi, usei guzzle e serviços, provedores e uma futura implementação de fachadas para abstrair um pouco mais.",
            },
            tenancy: {
                title: 'Multitenancy na Pratica - Kevin Mckee - Laracast',
                description: "Criei uma PR que fazia a atualização do Laravel 7.x para o Laravel 8.x usando o Sail, esse projeto foi feito pela Laracast com o Professor KEVIN MCKEE, apenas atualizei ele",
            },
            asaas: {
                title: 'Asaas SDK - Não oficial',
                description: "Criei uma funcionalidade que não havia no pacote do asaas que é o de enviar a conta principal para o asaas, essa conta principal é utilizada para receber o pagamento de faturas sem a necessidade de cadastrar manualmente",
            }
        }
    }
}
